export const API_BASE_URL = 'https://vom-dashboard-api.smartminesafety.com/v1/';
export const IMAGE_API_BASE_URL = 'https://vom-image-api.smartminesafety.com/v1/';
export const USER_POOL_ID = 'us-west-2_EoQGPyATp';
export const CLIENT_ID = '7fq155uma886b2nsljek06asuj';
export const IMAGE_BASE_URL = 'https://s3.us-west-2.amazonaws.com/vom-images.smartminesafety.com/';